<div class="pr-7 pl-4 pt-8 pb-6">
    <div (click)="activeModal.close()" class="close-modal mr-n4 mt-n7">
        <app-icon [type]="'ThinCross'"></app-icon>
    </div>
    <h3 class="modal-title">{{ title }}</h3>
</div>
